import { motion } from "framer-motion";

const EVENTS = [
  { year: "1946", title: "Naissance à Toulouse",         place: "Ville rose · 3 avril",        note: "Fils de réfugié politique catalan." },
  { year: "1963", title: "Première exposition",           place: "17 ans",                     note: "L'entrée dans la vie d'artiste." },
  { year: "1966", title: "Psychophysiographie",           place: "Concept",                    note: "Corps, esprit et geste artistique." },
  { year: "1980", title: "À Pierre-Paul Riquet",          place: "Bassin de Saint-Ferréol",    note: "Sculpture-hommage · toujours en place aujourd'hui." },
  { year: "1989", title: "Exposition en URSS",            place: "Seul artiste occidental invité", note: "Rideau de fer entrouvert." },
  { year: "2000", title: "Grotte de Bédeilhac",           place: "Parc de la Préhistoire · Ariège", note: "« 33 questions sur l'art »." },
  { year: "2001", title: "Institut Franco-Japonais",      place: "Fukuoka · Japon",            note: "Traversée d'un océan symbolique." },
  { year: "2016", title: "Palais du Facteur Cheval",      place: "Hauterives · Drôme",         note: "« Les Egos étranges »." },
  { year: "2018", title: "Château de Laréole",            place: "Rétrospective · Haute-Garonne", note: "« Michel Batlle, artiste en plein vent »." },
  { year: "2026", title: "Le Fil du Midi",                place: "Bassin de Saint-Ferréol",    note: "Carte blanche · 30 sculptures · 29 artistes invités.", highlight: true },
];

export default function BatlleTimeline() {
  return (
    <section className="mt-24 md:mt-32 px-6 md:px-12 max-w-[1400px] mx-auto" data-testid="batlle-timeline">
        <div className="flex items-baseline justify-between flex-wrap gap-4">
          <div className="meta-label text-cinabre">§ Chronologie · 80 ans, 60 ans de création</div>
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-fg/50">Dix étapes clés · 1946 → 2026</div>
        </div>

      <div className="mt-10 relative">
        {/* Vertical line */}
        <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-fg/15 -translate-x-1/2 md:-translate-x-[0.5px]" />

        <ol className="space-y-10 md:space-y-16">
          {EVENTS.map((e, i) => (
            <motion.li
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: 0.05 * (i % 3) }}
              className={`relative grid md:grid-cols-2 md:gap-16 ${i % 2 === 0 ? "" : "md:[direction:rtl]"}`}
            >
              {/* Dot */}
              <span className={`absolute left-4 md:left-1/2 top-1 w-3 h-3 border rounded-full -translate-x-1/2 ${e.highlight ? "bg-cinabre border-cinabre" : "bg-bg border-fg/40"}`} />

              {/* Card */}
              <div className={`pl-12 md:pl-0 md:[direction:ltr] ${i % 2 === 0 ? "md:pr-12 md:text-right" : "md:pl-12 md:col-start-2"}`}>
                <div className={`font-mono text-[10px] tracking-[0.24em] uppercase ${e.highlight ? "text-cinabre" : "text-fg/50"}`}>
                  § {e.year}
                </div>
                <h3 className="mt-2 font-serif text-3xl md:text-4xl leading-[1.05] tracking-tight">
                  {e.title}
                </h3>
                <div className="mt-2 font-mono text-[11px] tracking-[0.2em] uppercase text-fg/60">
                  {e.place}
                </div>
                {e.note && (
                  <p className="mt-3 font-serif italic text-lg text-fg/75 leading-snug">{e.note}</p>
                )}
              </div>

              {/* Spacer for opposite side */}
              <div className="hidden md:block" />
            </motion.li>
          ))}
        </ol>
      </div>

      <div className="mt-10 font-mono text-[10px] tracking-[0.24em] uppercase text-fg/40 text-center">
        Chronologie vérifiée — sources : Wikipédia, La Dépêche, Conseil départemental Haute-Garonne, Facteur Cheval
      </div>
    </section>
  );
}
